/**
 * @fileoverview GET handler for the "/alloys/partners/datadog/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { alloysPartnersDatadogAppGroupId } from "./constants";
import type { GetAlloysPartnersDatadogAppGroupIdResult } from "./types";
import { isGetAlloysPartnersDatadogAppGroupIdResult } from "./validators";

export const getAlloysPartnersDatadogAppGroupId = reactQueryFetcherAdapter(
  alloysPartnersDatadogAppGroupId,
  (signal: AbortSignal, appGroupId: string): Promise<GetAlloysPartnersDatadogAppGroupIdResult> => {
    return fetch(
      `/alloys/partners/datadog/${appGroupId}`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetAlloysPartnersDatadogAppGroupIdResult
);
